import React, { FunctionComponent } from "react";
import styles from "./BackgroundVideo.module.scss";
import BackgroundVideoProps from "./BackgroundVideoProps.interface";

import useWrapperStyles from "./hooks/useWrapperStyles";

import combineClasses from "helpers/combine-classes";
import VideoEmbed from "components/VideoEmbed/VideoEmbed";
import VideoViewer from "components/VideoViewer/VideoViewer";

const BackgroundVideo: FunctionComponent<BackgroundVideoProps> = (props): JSX.Element => {
    const wrapperStylesElementRef = useWrapperStyles(props);
    const video = props.content?.video?.[0] && props.content?.video.length > 0 ? props.content.video[0].content : undefined;

    return (
        <div className={combineClasses(styles.wrapper, props.className)} ref={wrapperStylesElementRef}>
            {/* Local Video */}
            {video && video._contentType === "blockVideoNestedLocal" && video.video?.umbracoFile ? (
                <VideoViewer key={video.video?.umbracoFile} src={video.video?.umbracoFile} autoplay={true} loop={true} controls={false} aspectRatioX={video.video?.umbracoWidth} aspectRatioY={video.video?.umbracoHeight} />
            ) : null}

            {/* Video Embed */}
            {video && video._contentType === "blockVideoNestedYouTube" && video.videoUrl ? (
                <VideoEmbed key={video.videoUrl} src={video.videoUrl} autoplay={true} loop={true} aspectRatioX={16} aspectRatioY={9} />
            ) : null}
        </div>
    );
};

export default BackgroundVideo;